import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import useFetch from "../../../../hooks/useFetch";
import { setAdhesionMandat } from "../../../../redux/AdherentRedux";
import { RootState } from "../../../../redux/reducers";
import { IbanBicResource } from "../../../../services/Api/swagger";

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useRenouvellementPrelevement = (
  numeroAdhesion,
  selectedAdherent,
  setConfirmationMandat
) => {
  const methods = useForm<{
    iban: string;
    bic: string;
    nomTitulaire: string;
    confirmationMandat: boolean;
  }>({
    mode: "onBlur",
    reValidateMode: "onBlur",
    criteriaMode: "all",
    defaultValues: {
      nomTitulaire:
        selectedAdherent &&
        selectedAdherent.prenom + " " + selectedAdherent.nom,
    },
  });

  const [paramsMandat, setParamsMandat] = useState<
    IbanBicResource | undefined
  >();
  const {
    response: verifyMandat,
    fetching: fetchingVerifyMandat,
    error: errorVerifyMandat,
  } = useFetch<number>(
    paramsMandat,
    "verifyMandat",
    paramsMandat ? true : false
  );
  const {
    watch,
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    clearErrors,
  } = methods;

  const [shouldExecuteMandat, setShouldExecuteMandat] = useState<boolean>(
    false
  );
  const [paramsMandatToSave, setParamsMandatToSave] = useState<
    any | undefined
  >();
  const {
    response: responseMandat,
    fetching: fetchingMandat,
    error: errorMandat,
  } = useFetch<number>(
    paramsMandatToSave,
    "putMandatByNumeroAdhesion",
    shouldExecuteMandat && paramsMandatToSave && paramsMandatToSave.iban
      ? true
      : false
  );
  const onSubmit = (data) => {
    setParamsMandatToSave({
      ...data,
      numeroAdhesion: numeroAdhesion,
    });
    setShouldExecuteMandat(true);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (responseMandat) {
      dispatch(setAdhesionMandat(paramsMandatToSave));
      setConfirmationMandat(true);
    }
  }, [responseMandat]);

  return {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    setValue,
    clearErrors,
    paramsMandat,
    setParamsMandat,
    onSubmit,
    verifyMandat,
    fetchingVerifyMandat,
    errorVerifyMandat,
    responseMandat,
    fetchingMandat,
    errorMandat,
  };
};
